export default __webpack_public_path__ + "static/media/hrm.78c8e4ea.svg";